import { PSI_PLATFORM_BE_URL } from './config';
import type { JWTUserData } from './auth/tokenManager';

/**
 * Canje de un código de acceso de UN SOLO USO por una sesión de psicóloga — `POST /api/auth/redeem-login-token`
 * en psiplatform-be (el código lo genera `generate-login-token`, hoy desde el backoffice de psima).
 *
 * Usa `fetch` directo y NO `beHttp`: `beHttp` agrega el Bearer, muestra toasts y, ante un 401, redirige al
 * login — justo lo contrario de lo que se quiere acá, donde un código vencido es un caso normal.
 */
export interface RedeemedSession {
  token: string;
  user: JWTUserData;
  scopes: string[];
}

const REDEEM_TIMEOUT_MS = 15_000;

export async function redeemLoginToken(code: string): Promise<RedeemedSession> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REDEEM_TIMEOUT_MS);
  try {
    const response = await fetch(`${PSI_PLATFORM_BE_URL}/api/auth/redeem-login-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: code }),
      signal: controller.signal,
    });
    if (!response.ok) throw new Error(`redeem-login-token respondió ${response.status}`);

    const json = (await response.json()) as {
      data?: { token?: string; user?: Partial<JWTUserData>; scopes?: string[] };
    };
    const data = json.data;
    if (!data?.token || !data.user?.id) throw new Error('Respuesta de canje inválida');

    return {
      token: data.token,
      user: {
        id: data.user.id,
        email: data.user.email ?? '',
        name: data.user.name ?? '',
        surname: data.user.surname ?? '',
      },
      scopes: data.scopes ?? [],
    };
  } finally {
    clearTimeout(timer);
  }
}
